import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getFormattedValue } from '../../../dashboardUtils';
import StatusCell from './StatusCell';
import { getStatusCellWidth, getCellThreshold } from './statusCellsUtils';

function StatusCellsGroup(props) {
    return (
        <div
            key={props.groupLabel}
            className="status-cells-wrapper"
            style={{ width: getStatusCellWidth(props.numberOfColumns) }}
        >
            <div className="status-cells-wrapper__title">
                {props.groupLabel}
            </div>
            {props.dataPoints.map((item) => (
                <StatusCell
                    key={item[props.groupBy]}
                    threshold={getCellThreshold(
                        item[props.metric],
                        props.thresholds
                    )}
                    label={item[props.groupBy]}
                    value={getFormattedValue(
                        item[props.metric],
                        props.suffix,
                        props.dataFormatter,
                        props.dataFormat
                    )}
                />
            ))}
        </div>
    );
}

StatusCellsGroup.propTypes = {
    dataFormat: PropTypes.string,
    dataFormatter: PropTypes.func.isRequired,
    groupBy: PropTypes.string.isRequired,
    groupLabel: PropTypes.string,
    dataPoints: PropTypes.instanceOf(Array).isRequired,
    metric: PropTypes.string.isRequired,
    numberOfColumns: PropTypes.number,
    suffix: PropTypes.string,
    thresholds: PropTypes.instanceOf(Array).isRequired,
};

StatusCellsGroup.defaultProps = {
    groupLabel: '',
    numberOfColumns: 1,
    suffix: '',
};

export default React.memo(StatusCellsGroup, (prevProps, nextProps) =>
    _.isEqual(prevProps.dataPoints, nextProps.dataPoints)
);
